import React from 'react';
import { motion } from 'framer-motion';
import { WHATSAPP_URL } from '../lib/constants';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'dark' | 'light';
  size?: 'md' | 'lg';
  className?: string;
  icon?: React.ReactNode;
}
export function CtaButton({
  children,
  variant = 'primary',
  size = 'lg',
  className = '',
  icon
}: CtaButtonProps) {
  const base = 'inline-flex items-center justify-center gap-2.5 rounded-full font-bold tracking-[-0.025em] transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-300';
  const sizes = {
    md: 'px-5 py-3 text-sm',
    lg: 'px-7 py-4 text-[0.95rem]'
  };
  const variants = {
    primary: 'bg-brand-500 text-white shadow-lg shadow-brand-500/25 hover:bg-brand-600',
    dark: 'bg-ink text-white shadow-lg shadow-ink/20 hover:bg-brand-800',
    light: 'bg-white text-ink shadow-lg shadow-ink/10 hover:bg-lime'
  };
  return <motion.a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.03,
    y: -1
  }} whileTap={{
    scale: 0.97
  }} transition={{
    type: 'spring',
    stiffness: 420,
    damping: 24
  }} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-12" data-mp="15b19qh8py8yl">
      {icon}
      <span data-id="element-13" data-mp="3f06yh3dhdv0c">{children}</span>
    </motion.a>;
}